import React from "react";
import { useI18n } from "../context/I18nContext";

export default function PolicyPage({ policyKey }) {
  const { t } = useI18n();
  const data = t(`policies.${policyKey}`);
  if (!data || !data.sections) return null;
  return (
    <main
      id="main"
      style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
      className="bg-white text-slate-800"
    >
      <div className="mx-auto max-w-4xl px-5 sm:px-8 lg:px-12 py-16 sm:py-20">
        <p
          className="text-xs font-mono uppercase tracking-[0.22em] text-emerald-700"
          style={{ fontFamily: "'JetBrains Mono', monospace" }}
        >
          {t("common.brand")} · {t("common.brandTag")}
        </p>
        <h1
          className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900"
          style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          data-testid={`policy-title-${policyKey}`}
        >
          {data.title}
        </h1>
        <p className="mt-3 text-sm text-slate-500">{data.updated}</p>
        <div className="mt-10 space-y-8">
          {data.sections.map((s, i) => (
            <section key={i} data-testid={`policy-${policyKey}-section-${i}`}>
              <h2
                className="text-xl sm:text-2xl font-semibold text-slate-900"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
              >
                {s.h}
              </h2>
              <p className="mt-2 text-slate-700 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
